// The wellness outreach text, filled in.
//
// The wording lives in Admin > Settings (wellness_outreach_message), because it
// is Allison's to write and rewrite - the old "wellness exam due" was a label
// for staff, not a message to a patient. The app only fills the blanks.
//
// A placeholder the template author misspelt is left as typed, so the mistake
// is visible in the reply box instead of vanishing into an empty space.

const KNOWN = ['firstName', 'provider', 'link', 'expires'] as const;
export const OUTREACH_TAGS = KNOWN;

/** What is sent when the practice has not written its own. */
export const STANDARD_OUTREACH_TEMPLATE =
  "Hi {firstName} — you're due for your wellness exam. Pick a time for your lab visit here: {link}. It works once and expires {expires}.";
type Placeholder = (typeof KNOWN)[number];

export type OutreachVars = Partial<Record<Placeholder, string | null | undefined>>;

const firstName = (full: string | null | undefined): string =>
  String(full || '').trim().split(/\s+/)[0] || 'there';

export function renderOutreach(template: string, vars: OutreachVars): string {
  const values: Record<Placeholder, string> = {
    firstName: firstName(vars.firstName),
    provider: String(vars.provider || ''),
    link: String(vars.link || ''),
    expires: String(vars.expires || ''),
  };
  return String(template || '').replace(/\{(\w+)\}/g, (whole, name: string) =>
    (KNOWN as readonly string[]).includes(name) ? values[name as Placeholder] : whole,
  );
}
